const errorMsg = {
    "-1":"网络出现问题请检查！",
    "100000":"账户不存在！",
    "100001":"账户状态异常,请联系管理员！",
    "100002":"账户未经授权,无法登录,请联系管理员！",
    "100003":"账户密码错误！",
    "100004":"登录超时,请重新登录！",
    "100005":"TOKEN超时,请重新登录！",
    "100006":"库存不足!",
    "100007":"货款余额不足!",
    "100008":"电话号已经存在无法申请！",
    "100009":"代理商业已经申请过该品牌！",
    "100010":"验证码为空！",
    "100011":"验证码不正确！",
    "100012":"证件上传失败！",
    "100013":"两次密码不一致！",
    "100015":"没有品牌！",
    "100016":"没有公司！",
    "100021":"该帐号正在审核！",
    "100022":"请联系管理员设置授权模板！",
    "100023":"手机号已存在！",
    "100024":"身份证号已存在！",
    "100025":"微信号已存在！",
    "100026":"姓名已存在！",
    "100027":"该品牌已存在，不能再申请！",
    "100028":"验证码已失效，请重新发送！",
    "100029":"账户验证码错误！",
    "100100":"上级积分不足!",
    "200000":"手机号码不能为空！",
    "200001":"密码不能为空！",
    "200002":"姓名不能为空！",
    "200003":"身份证不能为空！",
    "200004":"微信号不能为空！",
    "200005":"请选择性别！",
    "200006":"请选择出生年月！",
    "200007":"请选择地区！",
    "200008":"请输入手机号码！",
    "200010":"请输入验证码！",
    "200011":"请输入密码！",
    "200012":"请再次输入密码！",
    "200013":"密码不一致，请重新输入！",
    "200014":"参数不对,无法申请代理！",
    "200015":"请选择申请类别！",
    "200016":"企业申请请输入营业执照编号！",
    "200017":"请填写出身年月日！",
    "200018":"请选择地区！",
    "200019":"请填写验证码！",
    "200020":"确认密码不能为空！",
    "200021":"公司ID不能为空！",
    "200022":"品牌ID不能为空！",
    "200023":"代理级别ID不能为空！",
    "200024":"身份证书正面必须上传！",
    "200025":"身份证书反面必须上传！",
    "200026":"营业执照必须上传！",
    "100014":"没加入任何品牌",
    "200027":"请选择申请方式",
    "200028":"请选择汇款方式",
    "200030":"请上传汇款凭证",
    "200037":"请选择代理级别",
    "200038":"请选择品牌",


    "300002":"账户不存在！",
    "300003":"亲，没法再减少了！",
    "300004":"亲，达到库存上限了！",
    "300005":"请选择商品！",
    "300006":"请选择支付方式！",
    "300007":"请选择收货地址！",
    "300008":"请输入收货人姓名",
    "300009":"请输入联系方式",
    "300010":"请选择所在地区",
    "300011":"请输入详细地址",
    "300012":"请选择省份",
    "300013":"请选择市级",
    "300014":"请选择区县",
    "300015":"确定执行此操作?",
    "300016":"请输入开户人姓名",
    "300017":"输入银行卡账号",
    "300018":"请输入开户行名称",
    "300019":"请选择公司账户",
    "300020":"请输入充值金额",
    "300021":"请上传充值凭证",
    "300022":"充值订单提交成功，请等待审核",
    "300023":"请选择我们支持的图片格式！",
    "300024":"请选择3M以内的图片！",
    "300025":"上传图片出错！",
    "300026":"请输入旧密码",
    "300027":"请输入新密码",
    "300028":"新密码必须大于6位",
    "300029":"请确认新密码",
    "300030":"两次新密码不一致",
    "300031":"密码修改成功，请重新登录",
    "300032":"请先上传头像",
    "300033":"请上传付款凭证",
    "300034":"请选择订单货物类型",

    "0":"登录成功！",
    "1":"提交操作成功！",
    "2":"复制链接成功！",
    "600001":"添加操作失败！",
    "600002":"更新操作失败！",
    "600003":"删除操作失败！",
    "600004":"查询操作失败！",
    "600034":"老用户手机号、密码已失效，请绑定手机号并重置密码！",

    "400001":"请选择团队头像！",
    "400002":"请输入团队名称！",
    "400003":"请输入团队介绍！",
    "400004":"修改失败！",

    "500000":"手机号码不能为空！",
    "500001":"密码不能为空！",
    "500002":"手机验证码不能为空",
    "500003":"昵称不能为空",
    "500004":"手机号码已存在",
    "500005":"验证码不一致",
    "500006":"性别不能为空",
    "500007":"生日不能为空",

    "FILE NUM OVERLOAD":"上传图片数量不能超过两个！",
    "FILE ONE NUM OVERLOAD":"只能上传一张图片！",
    "100020":"奖励金不足!",
    
    "shop_000001":"操作成功",
    "shop_000002":"操作失败",
    "shop_000003":"参数错误",

    "shop_000007":"你已经帮他砍过价了~",
    "shop_000008":"已经砍到底了~",
    "shop_000009":"该商品您有正在进行或未开始的活动",
    "shop_000010":"你已经发起过相同的公司活动",
    "shop_000011":"你已经领取了该活动的奖励",
    "shop_000012":"未找到对应活动",



};

export {
	errorMsg
}



// WEBPACK FOOTER //
// ./src/config/page/cn/error/index.js